import { render, staticRenderFns } from "./SingleElementGenerator.vue?vue&type=template&id=2a844939&scoped=true&"
import script from "./SingleElementGenerator.vue?vue&type=script&lang=js&"
export * from "./SingleElementGenerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a844939",
  null
  
)

export default component.exports